import React from "react";
import ReactDOM from "react-dom";

import ArticleSection from "./ArticleSection";

const articleSections = document.getElementsByClassName("ArticleSection");

if (articleSections) {
  for (let i = 0; i < articleSections.length; i++) {
    let dataset = articleSections[i].dataset;

    ReactDOM.render(
      <ArticleSection
        contentId={dataset.contentid ? dataset.contentid : null}
        matchedCategoryIds={dataset.matchedcategoryids ? dataset.matchedcategoryids : null}
      />,
      articleSections[i]
    );
  }
}
